module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAaIAAAH0AgMAAAACssEWAAAACVBMVEUAAAD///////9zeKVjAAAAAnRSTlMAnxYjQ+0AAACTSURBVHja7c2hEcAgAMBARusS3afzdEp0BBIB928jMgAAAAAAAAAAAAAAAAAAAAAAAAAAALjO/y2Ck1M5OZWTUzk5lZNTOTmVk1M5OZWTUzk5lZNTOTmVk1M5OZWTUzk5lZNTOTmVk1M5OZWTUzk5lZNTOTmVk1M5OZWTUzk5bfY+AwAAAAAAAAAAAAAAAAAAgKNMkr6kuDlY7F4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/2.png
// module id = 186
// module chunks = 0